import { render, staticRenderFns } from "./electricity.vue?vue&type=template&id=54707c0a&scoped=true&"
import script from "./electricity.vue?vue&type=script&lang=js&"
export * from "./electricity.vue?vue&type=script&lang=js&"
import style0 from "./electricity.vue?vue&type=style&index=0&id=54707c0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54707c0a",
  null
  
)

export default component.exports